import {
    LookupModel,
    TenantsEnum,
    DocumentTypesEnum,
    ClientStatusesEnum,
    ImportFileTypesEnum,
    PaymentStatusesEnum,
    OperatorStatusesEnum,
    DocumentStatusesEnum,
    UserBehaviourTypesEnum,
    ClientUserStatusesEnum,
    ClientStatusTriggersEnum,
    AddressDocumentTypesEnum,
    IdentityDocumentTypesEnum,
    TradingAccountStatusesEnum,
    DocumentStatusTriggersEnum,
    OperatorStatusTriggersEnum,
    IdentityDocumentStatusesEnum,
    ClientUserStatusTriggersEnum,
    TradingGroupBehaviorTypesEnum,
    PaymentRequestStatusTriggersEnum,
    FundOrderStatusesEnum,
    FundOrderStatusTriggersEnum,
    PortalsEnum,
    PortalModel,
    AdjustmentCategoryEnum,
    MarketDataAgreementTypesEnum,
    TradingPlanStatusEnum,
    TradingPlanStatusTriggerEnum,
    TradingPlanSubTypeEnum,
    TradingPlanPrizeTypeEnum,
    TradingPlanTypeEnum,
    ExecutionBrokerStatusEnum,
    TradingPlanSuccessfulCompletionEnum,
    AccountPlanStatusEnum,
    AccountPlanStatusTriggerEnum, IndividualFilterModel
} from '@spa/api';

import {
    TradingAccountTypesEnum,
    TradingGroupClientTypesEnum,
    TradingGroupIsDefaultTypesEnum
} from 'appEntries/panel/enums';

import { PermissionsEnumHelper } from './enums';

import { variables } from 'appAssets/tenants/variables';
import { TextsHelper } from './texts.helper';
import { AutocompleteOptionInterface, SelectOptionInterface } from 'appShared/components';

export class EnumsHelper {
    private constructor() {
    }

    static permissionsEnumHelper = () => PermissionsEnumHelper;

    static getDocumentStatusByTrigger(trigger: number): number {
        switch (trigger) {
            case DocumentStatusTriggersEnum.New:
                return DocumentStatusesEnum.New;
            case DocumentStatusTriggersEnum.InReview:
                return DocumentStatusesEnum.InReview;
            case DocumentStatusTriggersEnum.Approved:
                return DocumentStatusesEnum.Approved;
            case DocumentStatusTriggersEnum.Archived:
                return DocumentStatusesEnum.Archived;
            case DocumentStatusTriggersEnum.Expired:
                return DocumentStatusesEnum.Expired;
            case DocumentStatusTriggersEnum.Declined:
                return DocumentStatusesEnum.Declined;
        }
    }

    static getDocumentStatusTriggerByStatus(status: number): number {
        switch (status) {
            case DocumentStatusesEnum.New:
                return DocumentStatusTriggersEnum.New;
            case DocumentStatusesEnum.InReview:
                return DocumentStatusTriggersEnum.InReview;
            case DocumentStatusesEnum.Approved:
                return DocumentStatusTriggersEnum.Approved;
            case DocumentStatusesEnum.Archived:
                return DocumentStatusTriggersEnum.Archived;
            case DocumentStatusesEnum.Expired:
                return DocumentStatusTriggersEnum.Expired;
            case DocumentStatusesEnum.Declined:
                return DocumentStatusTriggersEnum.Declined;
        }
    }

    static getClientStatuses(): LookupModel {
        return new LookupModel({
            [ClientStatusesEnum.New]: 'New',
            [ClientStatusesEnum.PendingDocuments]: 'Pending Documents',
            [ClientStatusesEnum.PendingAcceptance]: 'Pending',
            [ClientStatusesEnum.InVerifications]: 'For Verifications',
            [ClientStatusesEnum.OnHold]: 'On Hold',
            [ClientStatusesEnum.Verified]: 'Verified',
            [ClientStatusesEnum.Blocked]: 'Blocked',
            [ClientStatusesEnum.Active]: 'Active',
            [ClientStatusesEnum.Terminated]: 'Terminated',
            [ClientStatusesEnum.Declined]: 'Declined'
        });
    }

    static getClientInEnrollStatuses(): number[] {
        return [
            ClientStatusesEnum.New,
            ClientStatusesEnum.PendingDocuments,
            ClientStatusesEnum.PendingAcceptance
        ];
    }

    static getClientStatusByTrigger(trigger: number): number {
        switch (trigger) {
            case ClientStatusTriggersEnum.PendingAcceptance:
                return ClientStatusesEnum.PendingAcceptance;
            case ClientStatusTriggersEnum.ForVerification:
                return ClientStatusesEnum.InVerifications;
            case ClientStatusTriggersEnum.PutOnHold:
                return ClientStatusesEnum.OnHold;
            case ClientStatusTriggersEnum.Verify:
                return ClientStatusesEnum.Verified;
            case ClientStatusTriggersEnum.Block:
                return ClientStatusesEnum.Blocked;
            case ClientStatusTriggersEnum.Activate:
                return ClientStatusesEnum.Active;
            case ClientStatusTriggersEnum.Terminate:
                return ClientStatusesEnum.Terminated;
            case ClientStatusTriggersEnum.Decline:
                return ClientStatusesEnum.Declined;
        }
    }

    static getClientStatusTriggerByStatus(status: number): number {
        switch (status) {
            case ClientStatusesEnum.PendingDocuments:
                return ClientStatusTriggersEnum.PendingDocuments;
            case ClientStatusesEnum.PendingAcceptance:
                return ClientStatusTriggersEnum.PendingAcceptance;
            case ClientStatusesEnum.InVerifications:
                return ClientStatusTriggersEnum.ForVerification;
            case ClientStatusesEnum.OnHold:
                return ClientStatusTriggersEnum.PutOnHold;
            case ClientStatusesEnum.Verified:
                return ClientStatusTriggersEnum.Verify;
            case ClientStatusesEnum.Blocked:
                return ClientStatusTriggersEnum.Block;
            case ClientStatusesEnum.Active:
                return ClientStatusTriggersEnum.Activate;
            case ClientStatusesEnum.Terminated:
                return ClientStatusTriggersEnum.Terminate;
            case ClientStatusesEnum.Declined:
                return ClientStatusTriggersEnum.Decline;
        }
    }

    static getPaymentStatusTriggerByStatus(status: number): number {
        switch (status) {
            case PaymentStatusesEnum.New:
                return PaymentRequestStatusTriggersEnum.New;
            case PaymentStatusesEnum.ForApproval:
                return PaymentRequestStatusTriggersEnum.ForApproval;
            case PaymentStatusesEnum.OnHold:
                return PaymentRequestStatusTriggersEnum.OnHold;
            case PaymentStatusesEnum.Pending:
                return PaymentRequestStatusTriggersEnum.Pending;
            case PaymentStatusesEnum.Rejected:
                return PaymentRequestStatusTriggersEnum.Rejected;
            case PaymentStatusesEnum.Processed:
                return PaymentRequestStatusTriggersEnum.Processed;
            case PaymentStatusesEnum.Canceled:
                return PaymentRequestStatusTriggersEnum.Canceled;
            case PaymentStatusesEnum.Approved:
                return PaymentRequestStatusTriggersEnum.Approved;
            case PaymentStatusesEnum.CanceledByClient:
                return PaymentRequestStatusTriggersEnum.CanceledByClient;
            case PaymentStatusesEnum.Completed:
                return PaymentRequestStatusTriggersEnum.Completed;
            case PaymentStatusesEnum.ApprovedByOperator:
                return PaymentRequestStatusTriggersEnum.ApprovedByOperator;
            case PaymentStatusesEnum.Processing:
                return PaymentRequestStatusTriggersEnum.Processing;
        }
    }
    static getPaymentStatusByTrigger(status: number): number {
        switch (status) {
            case PaymentRequestStatusTriggersEnum.New:
                return PaymentStatusesEnum.New;
            case PaymentRequestStatusTriggersEnum.ForApproval:
                return PaymentStatusesEnum.ForApproval;
            case PaymentRequestStatusTriggersEnum.OnHold:
                return PaymentStatusesEnum.OnHold;
            case PaymentRequestStatusTriggersEnum.Pending:
                return PaymentStatusesEnum.Pending;
            case PaymentRequestStatusTriggersEnum.Rejected:
                return PaymentStatusesEnum.Rejected;
            case PaymentRequestStatusTriggersEnum.Processed:
                return PaymentStatusesEnum.Processed;
            case PaymentRequestStatusTriggersEnum.Canceled:
                return PaymentStatusesEnum.Canceled;
            case PaymentRequestStatusTriggersEnum.Approved:
                return PaymentStatusesEnum.Approved;
            case PaymentRequestStatusTriggersEnum.ApprovedByOperator:
                return PaymentStatusesEnum.ApprovedByOperator;
            case PaymentRequestStatusTriggersEnum.Processing:
                return PaymentStatusesEnum.Processing;
            case PaymentRequestStatusTriggersEnum.CanceledByClient:
                return PaymentStatusesEnum.CanceledByClient;
            case PaymentRequestStatusTriggersEnum.Completed:
                return PaymentStatusesEnum.Completed;
        }
    }

    static getClientUserStatusByTrigger(trigger: number): number {
        switch (trigger) {
            case ClientUserStatusTriggersEnum.ForConfirmation:
                return ClientUserStatusesEnum.ForConfirmation;
            case ClientUserStatusTriggersEnum.ForVerification:
                return ClientUserStatusesEnum.ForVerification;
            case ClientUserStatusTriggersEnum.Reject:
                return ClientUserStatusesEnum.Rejected;
            case ClientUserStatusTriggersEnum.Verify:
                return ClientUserStatusesEnum.Verified;
            case ClientUserStatusTriggersEnum.Decline:
                return ClientUserStatusesEnum.Declined;
            case ClientUserStatusTriggersEnum.Activate:
                return ClientUserStatusesEnum.Active;
            case ClientUserStatusTriggersEnum.ForDeactivation:
                return ClientUserStatusesEnum.ForDeactivation;
            case ClientUserStatusTriggersEnum.Deactivate:
                return ClientUserStatusesEnum.Deactivated;
            case ClientUserStatusTriggersEnum.Block:
                return ClientUserStatusesEnum.Blocked;
        }
    }

    static getClientUserStatusTriggerByStatus(status: number): number {
        switch (status) {
            case ClientUserStatusesEnum.ForConfirmation:
                return ClientUserStatusTriggersEnum.ForConfirmation;
            case ClientUserStatusesEnum.ForVerification:
                return ClientUserStatusTriggersEnum.ForVerification;
            case ClientUserStatusesEnum.Rejected:
                return ClientUserStatusTriggersEnum.Reject;
            case ClientUserStatusesEnum.Verified:
                return ClientUserStatusTriggersEnum.Verify;
            case ClientUserStatusesEnum.Declined:
                return ClientUserStatusTriggersEnum.Decline;
            case ClientUserStatusesEnum.Active:
                return ClientUserStatusTriggersEnum.Activate;
            case ClientUserStatusesEnum.ForDeactivation:
                return ClientUserStatusTriggersEnum.ForDeactivation;
            case ClientUserStatusesEnum.Deactivated:
                return ClientUserStatusTriggersEnum.Deactivate;
            case ClientUserStatusesEnum.Blocked:
                return ClientUserStatusTriggersEnum.Block;

        }
    }

    static getIdentityDocumentStatuses(): string[] {
        return [
            IdentityDocumentStatusesEnum.Pending,
            IdentityDocumentStatusesEnum.WaitingForDocuments,
            IdentityDocumentStatusesEnum.Approved,
            IdentityDocumentStatusesEnum.Refused
        ];
    }

    static getDocumentTypes(): LookupModel {
        return new LookupModel({
            [DocumentTypesEnum.ProofOfIdentity]: 'Proof of identity',
            [DocumentTypesEnum.ProofOfAddress]: 'Proof of address',
            [DocumentTypesEnum.Selfie]: 'Selfie',
            [DocumentTypesEnum.Other]: 'Other'
        });
    }

    static getProofOfIdentityDocumentTypes(): LookupModel {
        return new LookupModel({
            [IdentityDocumentTypesEnum.Passport]: 'Passport',
            [IdentityDocumentTypesEnum.IdentityCard]: 'Identity card',
            [IdentityDocumentTypesEnum.DrivingLicense]: 'Driving license'
        });
    }

    static getProofOfAddressDocumentTypes(): LookupModel {
        return new LookupModel({
            [AddressDocumentTypesEnum.BankStatement]: 'Bank statement',
            [AddressDocumentTypesEnum.UtilityBill]: 'Utility bill'
        });
    }

    static getMarketDataAgreementDocumentSubTypes(): LookupModel {
        return new LookupModel({
            [MarketDataAgreementTypesEnum.NASDAQ]: 'NASDAQ Global Subscriber Agreement',
            [MarketDataAgreementTypesEnum.NASDAQUTP]: 'NASDAQ UTP Plan Subscriber Agreement',
            [MarketDataAgreementTypesEnum.CBOE]: 'CBOE Global Markets Data Subscriber Agreement',
            [MarketDataAgreementTypesEnum.NYSE]: 'NYSE Market Data Display Agreement',
        });
    }

    static getCompanyDocumentTypes(): LookupModel {
        return new LookupModel({
            [DocumentTypesEnum.CertificateOfIncorporation]: 'Certificate Of Incorporation',
            [DocumentTypesEnum.CertificateOfCurrentStanding]: 'Certificate Of Current Standing',
            [DocumentTypesEnum.ArticleOfAssociation]: 'Article Of Association',
            [DocumentTypesEnum.MemorandumOfAssociation]: 'Memorandum Of Association',
            [DocumentTypesEnum.RegisterOfDirectors]: 'Register Of Directors',
            [DocumentTypesEnum.RegisterOfShareholders]: 'Register Of Shareholders',
        });
    }

    static getMarketDataAgreementDocumentTypes(): LookupModel {
        return new LookupModel({
            [DocumentTypesEnum.MarketDataAgreement]: 'Market Data Agreement',
        });
    }

    static getFileImportDocumentTypes(): LookupModel {
        return new LookupModel({
            [ImportFileTypesEnum.Individuals]: 'Individuals',
            [ImportFileTypesEnum.Companies]: 'Companies',
            [ImportFileTypesEnum.Accounts]: 'Accounts',
            [ImportFileTypesEnum.TradingPlans]: 'TradingPlans',
            [ImportFileTypesEnum.OrderRoutes]: 'Order Routes'
        });
    }

    static getStatusGroupName(status: number): string {
        if (IndividualFilterModel.getLeadsStatuses().includes(status)) {
            return 'Leads';
        }else if (IndividualFilterModel.getVerificationStatuses().includes(status)) {
            return 'For Verification';
        }else if (IndividualFilterModel.getClientStatuses().includes(status)) {
            return 'Client';
        }

        return null;
    }

    static getLoginUrlByPortalId(tenantId: number, portalId: number): string {
        if (tenantId === TenantsEnum.Alaric) {
            switch (portalId) {
                case PortalsEnum.AlaricPro:
                    return variables.proRedirectUrl;
                case PortalsEnum.AlaricFundPortal:
                    return variables.fundRedirectUrl;
                case PortalsEnum.TenN:
                    return variables.tenEnRedirectUrl;
                case PortalsEnum.DemoAlaricPro:
                    return variables.proRedirectUrl;
                case PortalsEnum.HammerWeb:
                    return variables.hammerWebRedirectUrl;
                default:
                    return '';
            }
        }
        else if (tenantId === TenantsEnum.Prototype) {
            switch (portalId) {
                case PortalsEnum.PrototypeFundPortal:
                    return variables.fundRedirectUrl;
                default:
                    return '';
            }
        }

        return variables.proRedirectUrl;
    }

    static getConfidentialClientByTypeBehavior(type: number): string {
        if (type === UserBehaviourTypesEnum.Pro) {
            return variables.proPortalName;
        }

        return '';
    }

    static getDefaultTenantId(): number {
        return variables.tenant;
    }

    /**
     * Resolves the portal a client belongs to, for deriving the confidential client
     * and login url of outgoing auth links.
     *
     * The client's enrolment portal is authoritative. Assigned portals are only a
     * fallback: that list is unordered and holds every portal the user can reach, so
     * for a user with access to more than one it does not identify the product they
     * belong to (CRM-5144). EnrollPortalId is null for clients created before it was
     * introduced, which is what the fallback exists for.
     */
    static resolveClientPortalId(enrollPortalId: number, portals: PortalModel[]): number {
        if (enrollPortalId) {
            return enrollPortalId;
        }

        return (portals && portals.length > 0) ? portals[0].id : null;
    }

    static getClientNameByPortalId(tenantId: number, portalId: number): string {
        if (tenantId === TenantsEnum.Alaric) {
            switch (portalId) {
                case PortalsEnum.AlaricPro:
                    return variables.proPortalName;
                case PortalsEnum.AlaricFundPortal:
                    return variables.fundPortalName;
                case PortalsEnum.TenN:
                    return variables.tenEnPortalName;
                case PortalsEnum.DemoAlaricPro:
                    return variables.proPortalName;
                case PortalsEnum.HammerWeb:
                    return variables.hammerWebPortalName;
                default:
                    return '';
            }
        }
        else if (tenantId === TenantsEnum.Prototype) {
            switch (portalId) {
                case PortalsEnum.PrototypeFundPortal:
                    return variables.fundPortalName;
                default:
                    return '';
            }
        }

        return variables.proPortalName;
    }

    static getTradingAccountTypes(): number[] {
        return [
            TradingAccountTypesEnum.Cash,
            TradingAccountTypesEnum.Trading
        ];
    }

    static getCashAccountStatuses(): number[] {
        return [
            TradingAccountStatusesEnum.ForApproval,
            TradingAccountStatusesEnum.Active,
            TradingAccountStatusesEnum.WithdrawalRestricted,
            TradingAccountStatusesEnum.Blocked,
            TradingAccountStatusesEnum.Closed,
            TradingAccountStatusesEnum.Rejected,
        ];
    }

    static getTradingAccountStatuses(): number[] {
        return [
            TradingAccountStatusesEnum.ForApproval,
            TradingAccountStatusesEnum.Active,
            TradingAccountStatusesEnum.AwaitingFunding,
            TradingAccountStatusesEnum.Blocked,
            TradingAccountStatusesEnum.ClosedCancel,
            TradingAccountStatusesEnum.BlockOrderEntry,
            TradingAccountStatusesEnum.BlockShortSells,
            TradingAccountStatusesEnum.Closed,
            TradingAccountStatusesEnum.Rejected,
        ];
    }

    static getActiveTradingAccountStatuses(): number[] {
        return [
            TradingAccountStatusesEnum.Active,
            TradingAccountStatusesEnum.AwaitingFunding,
            TradingAccountStatusesEnum.WithdrawalRestricted,
            TradingAccountStatusesEnum.BlockOrderEntry,
            TradingAccountStatusesEnum.BlockShortSells,
            TradingAccountStatusesEnum.ClosedCancel
        ];
    }

    static getTradingGroupBehaviorTypes(clientType: number): number[] {
        switch (clientType) {
            case TradingGroupClientTypesEnum.Individual:
                return [
                    TradingGroupBehaviorTypesEnum.SpeciallyForIndividual,
                    TradingGroupBehaviorTypesEnum.ForAllIndividuals
                ];
            case TradingGroupClientTypesEnum.Company:
                return [
                    TradingGroupBehaviorTypesEnum.SpeciallyForCompany,
                    TradingGroupBehaviorTypesEnum.ForAllCompanies
                ];
            default:
                return [
                    TradingGroupBehaviorTypesEnum.SpeciallyForIndividual,
                    TradingGroupBehaviorTypesEnum.SpeciallyForCompany,
                    TradingGroupBehaviorTypesEnum.ForAllIndividuals,
                    TradingGroupBehaviorTypesEnum.ForAllCompanies,

                ];
        }
    }

    static getTradingGroupIsDefault(isDefaultOption: number): boolean {
        switch (isDefaultOption) {
            case TradingGroupIsDefaultTypesEnum.No:
                return false;
            case TradingGroupIsDefaultTypesEnum.Yes:
                return true;
            default:
                return null;
        }
    }

    static getOperatorStatusTriggerByStatus(status: number): number {
        switch (status) {
            case OperatorStatusesEnum.PendingConfirmation:
                return OperatorStatusTriggersEnum.PendingConfirmation;
            case OperatorStatusesEnum.Active:
                return OperatorStatusTriggersEnum.Activate;
            case OperatorStatusesEnum.Inactive:
                return OperatorStatusTriggersEnum.Inactivate;
            case OperatorStatusesEnum.Deleted:
                return OperatorStatusTriggersEnum.Delete;
        }
    }

    static getOperatorStatusByTrigger(status: number): number {
        switch (status) {
            case OperatorStatusTriggersEnum.PendingConfirmation:
                return OperatorStatusesEnum.PendingConfirmation;
            case OperatorStatusTriggersEnum.Activate:
                return OperatorStatusesEnum.Active;
            case OperatorStatusTriggersEnum.Inactivate:
                return OperatorStatusesEnum.Inactive;
            case OperatorStatusTriggersEnum.Delete:
                return OperatorStatusesEnum.Deleted;
        }
    }

    static getOrderStatusTriggerByStatus(status: number): number {
        switch (status) {
            case FundOrderStatusesEnum.New:
                return FundOrderStatusTriggersEnum.New;
            case FundOrderStatusesEnum.Pending:
                return FundOrderStatusTriggersEnum.Pending;
            case FundOrderStatusesEnum.Matched:
                return FundOrderStatusTriggersEnum.Matched;
            case FundOrderStatusesEnum.Rejected:
                return FundOrderStatusTriggersEnum.Rejected;
            case FundOrderStatusesEnum.Completed:
                return FundOrderStatusTriggersEnum.Completed;
            default:
                return null;
        }
    }

    static getAdjustmentCategoryOptions(): SelectOptionInterface[] {
        return Object.keys(AdjustmentCategoryEnum)
            .map(key => {
                return {
                    value: AdjustmentCategoryEnum[key],
                    label: TextsHelper.getAdjustmentCategoryName(AdjustmentCategoryEnum[key])
                };
            });
    }

    static getTradingPlanStatusTriggerByStatus(status: number): number {
        switch (status) {
            case TradingPlanStatusEnum.InActive:
                return TradingPlanStatusTriggerEnum.InActive;
            case TradingPlanStatusEnum.Purchasable:
                return TradingPlanStatusTriggerEnum.Purchasable;
            case TradingPlanStatusEnum.Active:
                return TradingPlanStatusTriggerEnum.Active;
            case TradingPlanStatusEnum.Expired:
                return TradingPlanStatusTriggerEnum.Expired;
            case TradingPlanStatusEnum.Set:
                return TradingPlanStatusTriggerEnum.Set;
            case TradingPlanStatusEnum.OnHold:
                return TradingPlanStatusTriggerEnum.OnHold;
            case TradingPlanStatusEnum.ActiveAndPurchasable:
                return TradingPlanStatusTriggerEnum.ActiveAndPurchasable;

        }
    }

    static getAccountPlanStatusTriggerByStatus(status: number): number {
        switch (status) {
            case AccountPlanStatusEnum.InProgress:
                return AccountPlanStatusTriggerEnum.InProgress;
            case AccountPlanStatusEnum.Successful:
                return AccountPlanStatusTriggerEnum.Successful;
            case AccountPlanStatusEnum.Failed:
                return AccountPlanStatusTriggerEnum.Failed;
            case AccountPlanStatusEnum.Rejected:
                return AccountPlanStatusTriggerEnum.Rejected;

        }
    }

    static getBrokerStatusTriggerByStatus(status: number): number {
        switch (status) {
            case ExecutionBrokerStatusEnum.Unspecified:
                return ExecutionBrokerStatusEnum.Unspecified;
            case ExecutionBrokerStatusEnum.InActive:
                return ExecutionBrokerStatusEnum.InActive;
            case ExecutionBrokerStatusEnum.Active:
                return ExecutionBrokerStatusEnum.Active;
        }
    }

    static getLookupModelasOptions(model: LookupModel): AutocompleteOptionInterface[] {
        return model.getTypeKeys().map((c: string): AutocompleteOptionInterface => {
            return {
                label: model.getTypeValue(c),
                value: Number(c),
            };
        });
    }
    static getLookupModelasAutoCompleteOptions(model: LookupModel): AutocompleteOptionInterface[] {
        return model.getTypeKeys().map((c: string): AutocompleteOptionInterface => {
            return {
                label: model.getTypeValue(c),
                value: c,
            };
        });
    }

    static getTradingPlanSubTypeAsOptions(): AutocompleteOptionInterface[] {
        return Object.keys(TradingPlanSubTypeEnum)
            .filter(k => isNaN(Number(k)))
            .map(key => {
                return {
                    value: TradingPlanSubTypeEnum[key],
                    label: TextsHelper.getTradingPlanSubTypeName(TradingPlanSubTypeEnum[key])
                };
            });
    }
    static getTradingPlanPrizeTypeAsOptions(): AutocompleteOptionInterface[] {
        return Object.keys(TradingPlanPrizeTypeEnum)
            .filter(k => isNaN(Number(k)))
            .map(key => {
                return {
                    value: TradingPlanPrizeTypeEnum[key],
                    label: TextsHelper.getTradingPlanPrizeTypeName(TradingPlanPrizeTypeEnum[key])
                };
            });
    }

    static getTradingPlanSuccessfulCompletionAsOptions(): AutocompleteOptionInterface[] {
        return Object.keys(TradingPlanSuccessfulCompletionEnum)
            .filter(k => isNaN(Number(k)))
            .map(key => {
                return {
                    value: TradingPlanSuccessfulCompletionEnum[key],
                    label: TextsHelper.getTradingPlanSuccessfulCompletionName(TradingPlanSuccessfulCompletionEnum[key])
                };
            });
    }

    static getDemoTradingPlanTypes(): number[] {
        return [
            TradingPlanTypeEnum.Demo,
            TradingPlanTypeEnum.Tryout,
            TradingPlanTypeEnum.Tournament
        ];
    }
    static getRealTradingPlanTypes(): number[] {
        return [
            TradingPlanTypeEnum.PrimeTrading,
            TradingPlanTypeEnum.FundedAccount
        ];
    }
    static getTradingPlanTypeAsOptions(isDemo?: boolean, exclude: TradingPlanTypeEnum[] = null): AutocompleteOptionInterface[] {
        let options = Object.keys(TradingPlanTypeEnum)
            .filter(k => isNaN(Number(k)));
        if(exclude && exclude.length > 0){
            options = options.filter(k => !exclude.includes(TradingPlanTypeEnum[k]))
        }
        if(isDemo!== null){
            if(isDemo){
                options = options.filter(k => EnumsHelper.getDemoTradingPlanTypes().includes(TradingPlanTypeEnum[k]))
            }else{
                options = options.filter(k => EnumsHelper.getRealTradingPlanTypes().includes(TradingPlanTypeEnum[k]))
            }
        }

        return options.map(key => {
                return {
                    value: TradingPlanTypeEnum[key],
                    label: TextsHelper.getTradingPlanTypeName(TradingPlanTypeEnum[key])
                };
            });
    }

}
